import React, { useCallback } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import {
  NEOVARSITY_MANAGEMENT_STATUS_TABS,
  setCurrentPage,
} from 'features/neovarsityManagement';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import styles from './NeovarsityManagementPage.module.scss';

function NeovarsityManagementPage() {
  const dispatch = useDispatch();

  const handleTabClick = useCallback(() => {
    dispatch(setCurrentPage(1));
  }, [dispatch]);

  return (
    <>
      <ElementSpacePlaceholder elementId="project-management" />
      <div className={styles.root}>
        <div className={styles.tabs}>
          {NEOVARSITY_MANAGEMENT_STATUS_TABS.map((tab, tabIndex) => (
            <NavLink
              key={tab.name}
              to={`/neovarsity/${tab.to}`}
              tabIndex={tabIndex}
              onClick={handleTabClick}
              className={({ isActive }) =>
                classNames(styles.tab, { [styles.tabActive]: isActive })
              }
            >
              {tab.name}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet />
    </>
  );
}

export default NeovarsityManagementPage;
